<template>
  <div class="faq-main">
    <div class="faq-main__content">
      <p class="content__headline">
        {{ title }}
      </p>

      <div class="content__blocks content__blocks_mobile">
        <faq-block
          v-for="item in menu"
          :id="item.id"
          :key="item.id"
          :title="item.title"
          :children="item.children"
        />
      </div>

      <div class="content__blocks content__blocks_desktop">
        <div>
          <faq-block
            v-for="item in evenMenuItems"
            :id="item.id"
            :key="item.id"
            :title="item.title"
            :children="item.children"
          />
        </div>
        <div>
          <faq-block
            v-for="item in oddMenuItems"
            :id="item.id"
            :key="item.id"
            :title="item.title"
            :children="item.children"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import FaqBlock from '@/components/FAQ/FaqBlock.vue';
import type { IFaqMenuBlock } from '@/components/FAQ/types';
import { computed } from 'vue';
import { sortByPriority } from '@/utils/arrays.utils';

interface IFaqMainProps {
  title: string;
  items: IFaqMenuBlock[];
}

const props = defineProps<IFaqMainProps>();

const menu = computed(() => {
  return sortByPriority(props.items);
});

const isEven = (num: number) => num % 2 === 0;

const evenMenuItems = computed(() => {
  return menu.value.filter((_item, index) => isEven(index));
});

const oddMenuItems = computed(() => {
  return menu.value.filter((_item, index) => !isEven(index));
});
</script>

<style scoped lang="scss">
.faq-main {
  background: #f5f6f8;
  display: flex;
  justify-content: center;

  &__content {
    max-width: 1200px;
    width: 100%;
    padding-top: 32px;
    padding-bottom: 32px;

    @include media-min-sm {
      padding-top: 56px;
      padding-bottom: 56px;
    }

    .content {
      &__headline {
        padding: 0 16px 24px;

        @include headline-4;

        @include media-min-sm {
          padding: 0 0 32px;

          @include headline-1;
        }
      }

      &__blocks {
        display: flex;
        gap: 12px;
        flex-wrap: wrap;

        &_mobile {
          > div {
            width: 100%;
          }
        }

        &_desktop {
          display: none;
        }

        @include media-min-sm {
          &_mobile {
            display: none;
          }

          &_desktop {
            display: flex;
            gap: 24px;

            > div {
              width: calc(50% - 12px);
              display: flex;
              flex-direction: column;
              gap: 24px;

              :deep(.faq-block) {
                padding: 32px;

                .faq-menu-block {
                  gap: 24px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
